// Serwis pobierający konfigurację aplikacji z backendu (m.in. flagi funkcji z .env / .env.local).
import { fetchWrapper } from "@/helpers/fetch-wrapper";

class AppConfigService {
  /**
   * Pobiera stan flag funkcji aplikacji.
   * @returns {Promise<{locationManagement: boolean}>}
   */
  async getFeatureFlags() {
    return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/app/feature-flags`);
  }
}

// Eksport pojedynczej instancji serwisu.
export default new AppConfigService();
